import { ISorter } from "@/models/tables";
import i18n from "@/i18n";

const configurationsSorters: ISorter[] = [
  {
    field: "name",
    label: i18n.t("_.name").toString()
  },
  {
    field: "enabled",
    label: i18n.t("_.status").toString()
  }
];

const categoriesSorters: ISorter[] = [
  {
    field: "name",
    label: i18n.t("_.name").toString()
  },
  {
    field: "enabled",
    label: i18n.t("_.status").toString()
  }
];

export { configurationsSorters, categoriesSorters };

export const NameSorter: () => ISorter = () => ({
  field: "name",
  label: i18n.t("_.name").toString()
});

export const CreatedAtSorter: () => ISorter = () => ({
  field: "created_at",
  label: i18n.t("_.date_added").toString()
});

export const StatusSorter: () => ISorter = () => ({
  field: "enabled",
  label: i18n.t("_.status").toString()
});

export const DefaultSorters: () => ISorter[] = () => [
  CreatedAtSorter(),
  NameSorter(),
  StatusSorter()
];
